import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { ShippingMethodCode } from '@web/shared/module/shop';
import { AdminShippingMethodContextOperationsResponse } from './admin-shipping-method-context-operations.response';
import { DictionaryCountry } from '@web/shared/module/dictionary';

@jsonObject
export class AdminShippingMethodCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminShippingMethodContextOperationsResponse)
  public readonly contextOperations!: AdminShippingMethodContextOperationsResponse;

  @jsonArrayMember(DictionaryCountry)
  public readonly countries!: DictionaryCountry[];
}
